import React from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Keep the copy clear of the Enable/Disable button, which ListItem positions absolutely.
  text: {
    paddingRight: 160,
    marginTop: 0,
    marginBottom: 0
  },
  title: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1.4
  },
  hint: {
    display: 'block',
    marginTop: 3,
    maxWidth: 620,
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary
  }
}));

/**
 * The label + one-line explanation for a client permission row. Shared so every row in the
 * permissions list reads the same, rather than each component styling its own <small> tag.
 */
export function SettingRowText({ title, hint }) {
  const classes = useStyles();

  return (
    <ListItemText
      className={classes.text}
      classes={{ primary: classes.title, secondary: classes.hint }}
      primary={title}
      secondary={hint}
    />
  );
}
